/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable default-case */
/* eslint-disable no-unreachable */
import { CustomImage, CustomPageHeader, Text } from '@src/components';
import BalanceInformation from './balanceInformation';
import iconFinish from '@src/assets/icons/icon-done.svg';
import { useCallback, useEffect, useState, Suspense, lazy } from 'react';
import { Steps } from 'antd';
import {
  getById,
  getCurrentLoadBalance,
  loadBalancesUpdate,
  setActiveStep,
} from '@src/store/slice/balanceUploadSlice';
import { useDispatch, useSelector } from 'react-redux';
import '@src/styles/balanceUpload/balanceUpload.scss';
import OrderSummary from './orderSummary';
import Payment from './payment';
import Completed from './Completed';
import {
  getLoadBalanceDetailsGetPagedList,
  setDetailTableFilterClear,
} from '@src/store/slice/balanceUploadDetailSlice';
import { useLocation } from 'react-router-dom';
import { handleAuthStatus, isCreditCardUser, Wait } from '@src/utils/utils';
import { getFaceValues } from '@src/store/slice/faceValuePopupSlice';
const FaceValuePopup = lazy(() => delayPopup(import('../faceValuePopup/faceValuePopup')));
const MaxValuePopup = lazy(() => delayPopup(import('../faceValuePopup/maxValuePopup')));

const { Step } = Steps;

const steps = [
  {
    title: <Text t="balanceInformation" />,
    content: BalanceInformation,
    key: 'balanceInformation',
  },
  {
    title: <Text t="orderSummary" />,
    content: OrderSummary,
    key: 'orderSummary',
  },
  {
    title: <Text t="payment" />,
    content: Payment,
    key: 'payment',
  },
  {
    title: <Text t="approval" />,
    content: Completed,
    key: 'approval',
  },
];
const activeStepKeys = steps.map((item) => item.key);

export function getProgressDot() {
  return (iconDot, { index, status }) =>
    status === 'finish' ? <CustomImage src={iconFinish} /> : index + 1;
}

export async function delayPopup(promise) {
  await Wait(2700);
  return promise;
}

const BalanceUpload = (props) => {
  const { activeStep } = useSelector((state) => state?.balanceUpload);
  const { customerVou } = useSelector((state) => state?.customer);
  const { userAuthorizationStatus } = useSelector((state) => state?.user);
  const [modalVisible, handleModalVisible] = useState(true);
  const dispatch = useDispatch();
  const location = useLocation();
  const [_step, _setStep] = useState(steps);

  const { currentLoadBalance, isMaxValuePopupOpen } = useSelector((state) => state?.balanceUpload);
  const { faceValues } = useSelector((state) => state?.faceValuePopup);

  useEffect(() => {
    dispatch(setDetailTableFilterClear());
  }, [dispatch]);

  useEffect(async () => {
    await dispatch(getFaceValues());
  }, [dispatch]);

  useEffect(async () => {
    const search = new URLSearchParams(props?.location?.search);
    const draftId = search.get('balanceId');
    if (!draftId && !location.state?.id) {
      await dispatch(getCurrentLoadBalance());
    } else if (location?.state?.id) {
      await dispatch(getById(location?.state?.id));
    } else {
      await dispatch(getById(draftId));
    }
  }, [dispatch, props]);

  const gotoSummaryPage = useCallback(async () => {
    await dispatch(
      loadBalancesUpdate({
        ...currentLoadBalance,
        // totalPaymentAmount: currentLoadBalance?.totalPaymentAmount,
        orderStatus: 10,
      }),
    );
  }, [currentLoadBalance, dispatch]);

  const stepChange = useCallback(
    async (current) => {
      if (activeStep - 1 === current) {
        if (current === 0) {
          await dispatch(
            getLoadBalanceDetailsGetPagedList({
              body: { loadBalanceId: currentLoadBalance?.id, showOnlyPriced: false },
              pageNumber: 1,
              isFilter: false,
            }),
          );
        }
        await dispatch(
          loadBalancesUpdate({
            ...currentLoadBalance,
            orderStatus:
              currentLoadBalance.orderStatus - 10 >= 0 ? currentLoadBalance.orderStatus - 10 : 0,
          }),
        );
      }
    },
    [activeStep, currentLoadBalance, dispatch],
  );

  const StepContent = steps?.find((item) => item.key === activeStepKeys[activeStep])?.content || (
    <> </>
  );
  useEffect(async () => {
    if (!customerVou?.pamId) return;
    if (
      !isCreditCardUser(customerVou) ||
      handleAuthStatus(userAuthorizationStatus || [], 'ApprovalAuthorizationGroup') ||
      handleAuthStatus(userAuthorizationStatus || [], 'PaymentAuthorizationGroup')
    ) {
      if (activeStepKeys[activeStep] === 'payment') {
        await gotoSummaryPage();
        await dispatch(setActiveStep(1));
      }

      const withOutPaymentTab = steps.filter((item) => item.key !== 'payment');
      if (withOutPaymentTab.length === steps.length || withOutPaymentTab.length !== 3) return;
      _setStep([...withOutPaymentTab]);
    }
  }, [customerVou]);

  const changeTab = (key) => {
    if (window.history.pushState) {
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set('page', key);
      window.history.pushState({ path: newUrl.href }, '', newUrl.href);
    }
  };

  const isShowTabName = () => {
    switch (activeStepKeys[activeStep]) {
      case 'balanceInformation':
        return changeTab('orderform');
      case 'orderSummary':
        return changeTab('ordersummary');
      case 'payment':
        return changeTab('orderpayment');
      case 'approval':
        return changeTab('orderresult');
    }
  };

  useEffect(() => {
    isShowTabName();
  }, [activeStepKeys[activeStep]]);

  return (
    <CustomPageHeader
      data-testid="balance-upload"
      title={<Text t="balanceUpload" />}
      showBreadCrumb
      showHelpButton
      routes={['ticketRestaurantHeader']}
    >
      <div className="row">
        <Steps
          onChange={stepChange}
          current={activeStep}
          className="card-order-steps"
          labelPlacement="vertical"
          progressDot={getProgressDot()}
        >
          {_step.map((item) => (
            <Step key={item.title} title={item.title} disabled={activeStep === 3} />
          ))}
        </Steps>
      </div>
      <StepContent />
      <Suspense fallback={null}>
        <MaxValuePopup currentLoadBalance={currentLoadBalance} isMaxValuePopupOpen={isMaxValuePopupOpen} />
      </Suspense>
      {setActiveStep && (
        <Suspense fallback={<Steps />}>
          {faceValues?.htmlType < 7 &&
            !faceValues?.isMainPageAccepted &&
            faceValues?.isMainPageClosed &&
            !faceValues?.isClosed &&
            Object.keys(faceValues)?.length > 0 && (
              <FaceValuePopup
                modalVisible={modalVisible}
                handleModalVisible={handleModalVisible}
                faceValues={faceValues}
                isMainPage={false}
              />
            )}
        </Suspense>
      )}
    </CustomPageHeader>
  );
};

export default BalanceUpload;
